import React from 'react';

/**
 * Returns the value from the previous render for a given state or prop.
 * Returns `undefined` on the first render.
 */
export const usePrevious = <T>(value: T): T | undefined => {
    const ref = React.useRef<T>();

    React.useEffect(() => {
        ref.current = value;
    });

    return ref.current;
};
